import { Box, Button, ButtonGroup, Flex, Heading, Text } from '@chakra-ui/react'
import { FC, useEffect, useMemo, useState } from 'react'
import Chart from 'react-apexcharts'

import useHome from '@hook/shared/use-home'

import { formattedValue } from '@helper/formattedValues'

import ChartsLoading from '../Loading'

interface IRuptureChartsProps {
  empresas: Array<number>
}

const RuptureCharts: FC<IRuptureChartsProps> = ({ empresas }) => {
  const { dataRupture, loadingRupture, getDataRupture } = useHome()
  const [tab, setTab] = useState(0)

  const chart = useMemo(() => {
    const hasData = dataRupture.length === 0

    return {
      options: {
        chart: {
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val: string) {
            return formattedValue(Number(val)) + ' %'
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        noData: {
          text: 'Não há dados suficiente para completar o gráfico'
        },
        grid: {
          show: !hasData
        },
        xaxis: {
          categories: ['Curvas'],
          labels: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      },
      series: dataRupture
        .filter((row: any) => row.distribuicao === (tab === 0 ? 'CD' : 'Loja'))
        .map((row: any) => ({
          name: `Curva ${row.curva}`,
          data: [row.percentual.toFixed(2)]
        }))
    }
  }, [dataRupture, tab])

  useEffect(() => {
    if (dataRupture.length === 0) {
      getDataRupture(empresas)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresas])

  return (
    <Box h="100%" p={6} mb={2} bg="white" borderRadius="8px" boxShadow="sm">
      <Flex alignItems="center" justifyContent="space-between" mb={6}>
        <Box>
          <Heading size="md">Ruptura 0 dias</Heading>
          <Text fontSize="sm" color="gray.600">
            Cálculo de produtos sem estoque
          </Text>
        </Box>
        <ButtonGroup
          size="sm"
          isAttached
          isDisabled={loadingRupture}
          variant="solid"
        >
          <Button
            colorScheme={tab === 0 ? 'green' : 'gray'}
            onClick={() => setTab(0)}
            mr="-px"
          >
            CD
          </Button>
          <Button
            colorScheme={tab === 1 ? 'green' : 'gray'}
            onClick={() => setTab(1)}
          >
            Loja
          </Button>
        </ButtonGroup>
      </Flex>

      <ChartsLoading isLoaded={!loadingRupture}>
        <Chart
          options={chart.options}
          series={chart.series}
          type="bar"
          width="100%"
          height="320px"
        />
      </ChartsLoading>
    </Box>
  )
}

export default RuptureCharts
